module.exports = __webpack_public_path__ + "img/map.9bb2a19.jpg";